export enum ERecipientInputTypes {
  TO = 'to',
  CC = 'cc',
  BCC = 'bcc'
}

export enum ERecipientInputItemTypes {
  CONTACT = 'contact',
  RECENT_PARTY = 'recent_party',
  GROUP = 'group',
  CUSTOM = 'custom'
}

export enum EDraftState {
  SAVING = 'saving',
  SAVED = 'saved',
  NOT_SAVED = 'notSaved',
  NOT_EDITED = 'notEdited'
}

export enum ESubmitState {
  SUBMITTING = 'submitting',
  IDLE = 'idle',
  SUBMITTED = 'submitted'
}

export enum EDraftSaveResponse {
  SKIPPED = 'skipped',
  SAVED = 'saved',
  VALIDATION_ERROR = 'validationError',
  NOTHING_TO_SAVE = 'nothingToSave'
}
